import {ChangeDetectionStrategy, Component, inject, Input} from '@angular/core';
import {MarketSeriesManager} from '../market-series-manager';
import {MarketSeries, PolicyEvent, YearRow} from '../policy-chart.models';

@Component({
  selector: 'app-fiscal-row-header',
  standalone: true,
  imports: [],
  templateUrl: './fiscal-row-header.component.html',
  styleUrl: './fiscal-row-header.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FiscalRowHeaderComponent {
  private readonly seriesManager = inject(MarketSeriesManager);

  @Input({required: true}) year!: YearRow;

  /** One stat block per feed the manager is showing. */
  get seriesStats(): MarketSeries[] {
    return this.seriesManager.visibleSeries(this.year)
      .filter((series) => series.low !== undefined && series.high !== undefined);
  }

  /** Only the events for banks the manager is showing. */
  private get visibleEvents(): PolicyEvent[] {
    return this.year.events.filter((event) =>
      this.seriesManager.showsEvent(event.bank));
  }

  get increaseCount(): number {
    return this.visibleEvents.filter((event) => (event.changePoints ?? 0) > 0).length;
  }

  get decreaseCount(): number {
    return this.visibleEvents.filter((event) => (event.changePoints ?? 0) < 0).length;
  }

  /** Meetings that have already happened and left the rate where it was. */
  get noChangeCount(): number {
    return this.visibleEvents.filter((event) =>
      event.isMeeting && !event.future && event.changePoints === undefined).length;
  }

  format(value: number): string {
    return Math.round(value).toLocaleString('en-US');
  }
}
